import { Slider } from 'components/slider'
import Slide1 from './assets/1_Rezeda Agliulova.webp'
import Slide2 from './assets/2_Aigel Salakhova.webp'
import Slide3 from './assets/3_Youryool.webp'
import Slide4 from './assets/4_Sultan.webp'
import Slide5 from './assets/5_Sahitan.webp'

export const SliderDesigners = () => (
  <Slider
    maximumWidth={542}
    imagesPerView={3}
    aspectRatio="542 / 845"
    capitalizeDescription
    slides={[
      {
        src: Slide2,
        title: 'Aigel Salakhova',
        overlayText: 'Aigel Salakhova',
        description:
          'Кожаные сумки ручной работы с национальной узорной мозаикой – многовековым художественным ремеслом татар',
        link: 'https://www.instagram.com/aigelsalakhova/?igshid=MzMyNGUyNmU2YQ%3D%3D',
      },
      {
        src: Slide4,
        title: 'Sultan',
        overlayText: 'Sultan',
        description:
          'Онлайн-магазин товаров ручной работы – от подушек и ковров до мюлей и кисетов',
        link: 'https://www.instagram.com/sultan_kazan/',
      },
      {
        src: Slide5,
        title: 'САХТИАН',
        overlayText: 'САХТИАН',
        description:
          'Обувь ручной работы с татарскими мотивами (ООО "Сахтиан", художники Гайнутдинов И.Х., Артемьева А.Н.)',
        link: 'https://instagram.com/sahtian11?igshid=YmMyMTA2M2Y=',
      },
    ]}
  />
)
